/* template */
<template><div :style="[(bgStyle)] | transRpxStyle" class="packet-open"><div v-for="(item, index) in (couponListGroupNewMap)" :key="item.product_id" class="coupon"><mpx-image src="https://ut-static.udache.com/webx/ut/oVyOC7VVBrr2O73q4x0Ly.png" class="cover" v-if="(item.disabaled)"></mpx-image><mpx-image src="https://ut-static.udache.com/webx/ut/ZOyagwxob9FpGM74uSAJC.png" class="failed" v-if="(item.disabaled)"></mpx-image><div :style="[(item.tabImageStyle)] | transRpxStyle" class="tag">{{item.product_line_tag_text}}<span v-if="(item.len > 1)">包</span></div><mpx-image @tap="couponClick(item)" src="https://ut-static.udache.com/webx/ut/Mn2FsSbutcB_CdldzPygy.png" class="icon"></mpx-image><mpx-view @tap="couponClick(item)" class="award"><div class="mark">立享</div><div class="amount">{{item.cap_amount}}</div><div class="unit">{{item.unit}}</div></mpx-view>"<mpx-view @tap="goToLink(item)" class="desc">{{item.product_line_text}}</mpx-view></div><mpx-image src="https://ut-static.udache.com/webx/ut/gXEUp_0RsGEpem7kPa2gM.png" class="coupon-cover"></mpx-image><mpx-button @tap="click" class="btn">{{ btnText }}</mpx-button></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7eec299c"}'>
  .packet-open
    display flex
    justify-content center
    align-items center
    box-sizing border-box
    position relative
    background-size 100% 100%
    background-repeat no-repeat
    width 750rpx
    height 560rpx
    background-size: 100% 100%
    background-image: url('https://ut-static.udache.com/webx/ut/tQhjiQMSE4dlrzpBIRlLX.png')
    background-repeat: no-repeat
    position relative
    margin-top 227rpx
    .coupon-cover
      position absolute
      bottom 0
      width 700rpx
      height 250rpx
    .coupon
      width 224rpx
      height 334rpx
      background-image url('https://ut-static.udache.com/webx/ut/jNgH89VIvOP45_rNFU-P1.png')
      background-size 100% auto
      background-repeat no-repeat
      position relative
      display flex
      flex-direction column
      align-items center
      .cover
        position: absolute
        width 224rpx
        height 334rpx
        background-image url('https://ut-static.udache.com/webx/ut/oVyOC7VVBrr2O73q4x0Ly.png')
        background-size 100% auto
        background-repeat no-repeat
      .failed
        width: 127rpx
        height: 127rpx
        position absolute
        right: 0
        top: 95rpx
      .tag
        position absolute
        top 0
        width: 161rpx
        height: 43rpx
        line-height: 43rpx
        background-size: 100% auto;
        background-repeat: no-repeat;
        font-family: PingFangSC-Medium;
        font-size: 20rpx;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 500;
      .icon
        position absolute
        right: 20rpx
        top: 20rpx
        width: 20rpx;
        height: 20rpx;
      .award
        position absolute
        top 47rpx
        display flex
        align-items: baseline;
        .mark
          width 38rpx
          height 18rpx
          line-height 18rpx
          position absolute
          right -10rpx
          top 10rpx
          font-family: PingFangSC-Regular;
          font-size: 14rpx;
          color: #FEF1D6;
          text-align: center;
          font-weight: 400;
          border: 1rpx solid #FEEFD0;
          border-radius: 10rpx;
        .amount
          height: 80rpx;
          font-family: UniSansHeavyCAPS, UniSansHeavyCAPS-self;
          font-size: 80rpx;
          color: #FEEFD0;
          letter-spacing: -2rpx;
          text-align: center;
          font-weight: 900;
        .unit
          width: 32rpx;
          height: 30rpx;
          font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
          font-size: 29.4rpx;
          color: #FEEFD0;
          letter-spacing: 2.2rpx;
          text-align: center;
          font-weight: 900;
      .desc
        position absolute
        bottom 100rpx
        width: 156rpx;
        height: 50rpx;
        line-height: 50rpx
        border: 2rpx solid rgba(255,240,206,1);
        border-radius: 25rpx;
        font-family: PingFangSC-Medium;
        font-size: 24rpx;
        color: #FFF2D5;
        letter-spacing: 0;
        text-align: center;
        text-shadow: 0 1rpx 0 #BD2715;
        font-weight: 500;
        z-index 2
    .btn
      position absolute
      bottom 0
      background-image: url('https://ut-static.udache.com/webx/ut/D7ichazJcxtQ_YqlbvcFN.apng');
      background-size: 100% auto
      background-repeat: no-repeat
      bottom: 0
      width 540rpx
      height 160rpx
      line-height 120rpx
      font-size: 48rpx;
      font-family: PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      text-align center
      margin-bottom 0
      letter-spacing 1.71rpx
      background-color: transparent

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7eec299c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./red-packet-open-cz.mpx.js?isComponent&outputPath=components%2Fred-packet-open-cz7eec299c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./red-packet-open-cz.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fred-packet-open-cz7eec299c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7eec299c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/red-packet-open-cz7eec299c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
